// GuitarServiceGalleriesServiceProvider.tsx
import { getAll, getOne } from '../services/CRUDServiceProvider';
import { GalleryImage } from '../types/galleryImage';
import { PaginatedResponse } from '../types/pagination';
import { Translated } from '../types/translated';
import { PaginationRequest } from '../types/pagination';

let url_path = 'guitar-service-galleries';

export interface GuitarServiceGallery {
    title: Translated;
    description: Translated;
    slug: string;
    status: string;
    guitar_service_gallery_images?: GalleryImage[];
};

export const getAllGuitarServiceGalleries = async (pagination: PaginationRequest, image_size: string | undefined): Promise<PaginatedResponse<GuitarServiceGallery>> => {
    //console.log(token);
    console.log(url_path);
    try {
        const response = await getAll<any>(url_path, pagination, image_size);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getGuitarServiceGallery = async (slug: string, image_size: string | undefined): Promise<GuitarServiceGallery> => {
    //console.log(token);
    console.log(url_path);
    try {
        const response = await getOne<any>(url_path, slug, image_size, undefined);
        return response.data;
    } catch (error) {
        throw error;
    }
};
